import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGoPage } from "../../hooks/useGoPage";
import { setWorks } from "../../redux";

import SelectLang from "../../components/SelectLang";
import Onglet from '../../components/Onglet';

import "./style.css"

function Works({ type }) {
    const goPage = useGoPage();
    const dispatch = useDispatch();
    const worksDb = useSelector(state => state.works);

    const [inSubmit, setInSubmit] = useState(false);
    const [worksList, setWorksList] = useState(null);

    localStorage.setItem('opt_return_work_pg_vanrah', 'works');

    useEffect(() => {
        if (!worksDb || worksDb.length === 0) {
            setWorksList(null);
            return
        }
        const worksTypeFiltered = worksDb.filter(w => w.type === parseInt(type));
        setWorksList(worksTypeFiltered);
    }, [worksDb, type]);

    const getPath = (work) => {
        const page_path = type === 1 ? 'manga' : 'work';
        const name_path = work?.title_path || 'newwork';
        return `${page_path}/${name_path}`;
    }

    const switchLeft = async (article) => {
        if (article.order === worksDb.length - 1) return
        const nextArticle = worksDb.find(i => i.order === article.order + 1 && i.type === type);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/works/order/${article._id}/${nextArticle._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newWorksList = worksDb.map(item => {
            if (item._id === article._id) {
                return { ...item, order: item.order + 1 };
            }
            else if (item._id === nextArticle._id) {
                return { ...item, order: item.order - 1 };
            }
            return item;
        });
        newWorksList.sort((a, b) => a.order - b.order);
        dispatch(setWorks(newWorksList))
    };

    const switchRight = async (article) => {
        if (article.order === 0) return
        const prevArticle = worksDb.find(i => i.order === article.order - 1 && i.type === type);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/works/order/${article._id}/${prevArticle._id}`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        if (req.status !== 200) return alert(res.message);

        const newWorksList = worksDb.map(item => {
            if (item._id === article._id) {
                return { ...item, order: item.order - 1 };
            }
            else if (item._id === prevArticle._id) {
                return { ...item, order: item.order + 1 };
            }
            return item;
        });
        newWorksList.sort((a, b) => a.order - b.order);
        dispatch(setWorks(newWorksList))
    };

    const handleMini = async (e, work) => {
        const file = e.target.files[0];
        if (!file) return alert('Aucune miniature renseignée');

        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const body = new FormData();
        body.append('title', work.title);
        body.append('mini', file, file.name);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/works/edit/${work._id}`, {
            method: 'PUT',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` },
            body
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 201 && req.status !== 200) {
            alert(res.message);
            return
        }

        const newWorkDb = worksDb.map(e => {
            if (e._id === work._id) return res;
            return e;
        });
        dispatch(setWorks(newWorkDb));
        alert('Miniature modifié avec succès !');
    }

    return (
        <div className='page page_works'>
            <p className='title_page'>
                - <span>{type === 1 ? 'Mangas/Webcomics' : 'Other Works'}</span> -
            </p>

            <SelectLang />

            <button
                className="btn_new_item"
                onClick={() => goPage(getPath())}
            >
                + Nouvelle oeuvre
            </button>

            {worksList &&
                <ul className="works_list">
                    {worksList.map((work, idx) => (
                        <li key={idx}>
                            <button className="input_miniature">
                                <i className="fas fa-image"></i>
                                <input type="file" onChange={(e) => handleMini(e, work)} />
                            </button>

                            {idx !== worksList.length - 1 &&
                                <button
                                    className="btn_bottom btn_panel"
                                    onClick={() => switchLeft(work)}
                                ><i className="fas fa-chevron-right"></i></button>
                            }

                            {idx !== 0 &&
                                <button
                                    className="btn_top btn_panel"
                                    onClick={() => switchRight(work)}
                                ><i className="fas fa-chevron-left"></i></button>
                            }

                            <Onglet data={work} idx={idx} getPath={getPath} lines={true} />
                        </li>
                    ))}
                </ul>
            }
        </div>
    )
}

export default Works;